<template>
  <div>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane
        v-for="item in tabs"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "ElTabsTabs",
  props: {
    active: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      default: () => [],
      required: true,
      validator: function (v) {
        return v.every((i) => i.label&&i.name&&Object.keys(i).length===2);
      },
    },
  },
  computed: {
    activeName: {
      get: function () {
        return this.active;
      },
      set: function (v) {
        this.$emit("update:active", v);
      },
    },
  },
  methods: {
    handleClick() {
      this.$emit("tab-click", this.activeName);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tabs--card > .el-tabs__header {
    border-bottom: 0px;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border-bottom-color: #e4e7ed;
    background-color: #fafafa;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #fff;
    background-color: #fff;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
  }
}
</style>